export default {
  mealsWireToInt,
  mealsIntToWire,
};

function mealsWireToInt (wireMeals) {
  if (!wireMeals || !wireMeals._attributes) {
    return {};
  }

  return {
    id: wireMeals._attributes.menuid,
    category: categoriesWireToInt(wireMeals.menuCategory),
  };
}

function categoriesWireToInt (wireCategories) {
  if (!wireCategories || !wireCategories.length) return [];
  let intCategories = [];
  for (let i = 0; i < wireCategories.length; i++) {
    intCategories.push(categoryWireToInt(wireCategories[ i ]));
  }
  return intCategories;
}

function categoryWireToInt (wireCategory) {
  return {
    label: wireCategory._attributes ? wireCategory._attributes.label : '',
    items: itemsWireToInt(wireCategory.menuItem),
  };
}

function itemsWireToInt (wireItems) {
  if (!wireItems || !wireItems.length) return [];
  let intItems = [];
  for (let i = 0; i < wireItems.length; i++) {
    intItems.push(itemWireToInt(wireItems[ i ]));
  }
  return intItems;
}

function itemWireToInt (wireItem) {
  const { _attributes, _cdata, options } = wireItem;
  if (options && options.option) {
    return {
      id: _attributes.menuitemid,
      description: _cdata,
      subselection: subselectionWireToInt(options),
    };
  }
  return {
    id: _attributes.menuitemid,
    description: _cdata,
  };
}

function subselectionWireToInt (subselection) {
  const { _attributes, _text } = subselection.option;
  let options = _text.split('~');
  for (let i = 0; i < options.length; i++) {
    options[ i ] = {
      id: options[ i ],
      description: options[ i ],
    };
  }
  return {
    label: _attributes ? _attributes.text : '',
    options,
  };
}

function mealsIntToWire (intMeals) {
  const { id, category } = intMeals;

  return {
    _menuid: id,
    _menuCategory: categoriesIntToWire(category),
  };
}

function categoriesIntToWire (intCategories) {
  if (!intCategories || !intCategories.length) return [];
  let wireCategories = [];
  for (let i = 0; i < intCategories.length; i++) {
    wireCategories.push(categoryIntToWire(intCategories[ i ]));
  }
  return wireCategories;
}

function categoryIntToWire (intCategory) {
  const { label, items } = intCategory;
  return {
    _label: label,
    _menuItem: itemsIntToWire(items),
  };
}

function itemsIntToWire (intItems) {
  if (!intItems || !intItems.length) return [];
  let wireItems = [];
  for (let i = 0; i < intItems.length; i++) {
    wireItems.push(itemIntToWire(intItems[ i ]));
  }
  return wireItems;
}

function itemIntToWire (intItem) {
  const { id, description } = intItem;
  return {
    _menuitemid: id,
    __text: description,
  };
}



// WEBPACK FOOTER //
// ./src/converter/MealsConverter.js